import { VIEW_CLASS } from '../style/constants';
const ignore = [
    '.sail-ignore-metrics',
    '.cm-editor',
    '.cm-editor *',
    'svg *',
    'link',
    'meta',
    'noindex',
    'noscript',
    'optgroup',
    'option',
    'slot',
    'script',
    'source',
    'style',
    'template',
    'title'
];
const emptyResult = {
    total: 0,
    stable: 0,
    deprecated: 0
};
export function unsafeCountDomElements({ element = document.body, denyList = [] } = {}) {
    if (!element) {
        return emptyResult;
    }
    const totalSelector = `:not(${denyList.concat(ignore).join(', ')})`;
    const deprecatedSelector = `[class*=sn-]${totalSelector}`;
    const stableSelector = `.${VIEW_CLASS}${totalSelector}`;
    return {
        total: element.querySelectorAll(totalSelector).length,
        stable: element.querySelectorAll(stableSelector).length,
        deprecated: element.querySelectorAll(deprecatedSelector).length
    };
}
export const countDomElements = (...args)=>{
    try {
        return unsafeCountDomElements(...args);
    } catch (e) {
        return emptyResult;
    }
};

//# sourceMappingURL=countDomElements.js.map